import React, { useState, useEffect } from 'react';
import {Dialog, DialogContent, Button, TextField, Alert, Stack, Box, Autocomplete, Typography} from "@mui/material";
import { format } from "date-fns";
import {Controller, SubmitHandler, useForm} from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
    jasperReportClientiVersoreBlob,
    useSendEmail,
    useUploadReport, validationSchema,
} from "../reportclientiversore/Services";
import {DittaList, EmailForm} from "./types";
import {ReportDateForm} from "./types";
import {useGetClienti} from "../gestpianatt/Services";
import {TipoMigList} from "../gestdatiprog/types";

interface ReportClientiVersoreJasperProps {
  onClose: () => void;
  propformato: string;
  propcodcli: string;
  propditta: string;
}

const ReportClientiVersoreJasper: React.FC<ReportClientiVersoreJasperProps> = (props) => {

  const today = format(new Date(), 'yyyy-MM-dd');
  const [blob, setBlob] = useState<Blob | null>(null);
  const [emailTo, setEmailTo] = useState('');
  const [idCli, setIdCli] = useState('');
  const [ditta, setDitta] = useState('2');


   const [datesConfirmed, setDatesConfirmed] = useState(false);



  const {  control,register, handleSubmit, formState: { isValid, errors } } = useForm({ resolver: yupResolver(validationSchema),
  defaultValues: {
    ditta: props.propditta || '',
    idcli: props.propditta+'-'+props.propcodcli || '',
  }
  });
  const { mutateAsync: uploadReport, isPending: isUploadingRicevuta } = useUploadReport();
  const { mutateAsync: sendEmail, isPending: isSendingEmail, isSuccess: isSuccessSendEmail } = useSendEmail();

  const {  data: ClientiApiResponse, refetch: refetchClienti } = useGetClienti(Number(ditta));

  const role = localStorage.getItem('keyrole') || '';

  let disableClientiDrop = false;

  if (role.includes('TimeReportCust')){
       disableClientiDrop = true
             };



  useEffect(() => {
    if (ditta) {
        refetchClienti();
      }
  }, [ditta]);


  // Fetch the blob when the component mounts
 // useEffect(() => {
 //    const fetchBlob = async () => {
 //      try {
 //          // console.log('props.propformato: ',props.propformato);
 //        const myBlob = await jasperReportCleintiVersoreBlob(props.propcodcli,props.propformato);
 //        if (myBlob) {
 //          // console.log('Blob loaded:', myBlob);
 //          setBlob(myBlob);
 //        } else {
 //          console.error('Failed to load blob');
 //        }
 //      } catch (error) {
 //        console.error('Error fetching blob:', error);
 //      }
 //    };
 //
 //    fetchBlob();
 //  }, [props.propcodcli,props.propformato]);
 //






  const handleDownload = () => {
    if (blob) {
      let myFileName = "ReportClienti."+props.propformato;;
      myFileName = myFileName.replace(/\//g, "-");

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = myFileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  };

  const handleEmail = async () => {
    if (blob) {
      const formData = new FormData();
      let myFileName = "ReportClienti."+props.propformato;
      myFileName = myFileName.replace(/\//g, "-");
      formData.append('file', blob, myFileName);

      await uploadReport(formData);

      const emailForm: EmailForm = {
        email: (emailTo || ''),
        subject: 'Report Clienti',
        attachment: myFileName,
        tipo: 'report',
      };

      await sendEmail(emailForm);
    }
  };

const onSubmit: SubmitHandler<ReportDateForm> = async (data) => {
  if (data.fromDate && data.toDate) {
    setDatesConfirmed(true);
    let myBlob: Blob | null = null;

    // console.log(props.propditta,props.propcodcli);

   if (props.propditta !== '' && props.propcodcli !== '' && props.propcodcli !== '0' ) {
      myBlob = await jasperReportClientiVersoreBlob(
        data.fromDate,
        data.toDate,
        props.propditta,
        props.propcodcli,
        props.propformato
      );
    } else {
      // console.log(idCli,idCli.split("-"))
      const [myDitta, myCodcli] = idCli.split("-");
      myBlob = await jasperReportClientiVersoreBlob(
        data.fromDate,
        data.toDate,
        myDitta,
        myCodcli,
        props.propformato
      );
    }

    if (myBlob) {
      setBlob(myBlob);
    }
  } else {
    setDatesConfirmed(false);
  }
};

  const handleClose = () => {
    props.onClose();
  };

  return (
        <Dialog onClose={props.onClose} open fullWidth={true} maxWidth={"md"}>
          <DialogContent>
            {!datesConfirmed && (
              <form onSubmit={handleSubmit(onSubmit)}>
                <Stack spacing={2}>
                  <Stack direction="row" spacing={2}>
                    <TextField
                      id="fromDate"
                      label="DataInizio"
                      type="date"
                      margin="dense"
                      fullWidth
                      defaultValue={today}
                      {...register('fromDate')}
                      error={!!errors.fromDate}
                    />
                    <TextField
                      id="toDate"
                      label="Data Fine"
                      type="date"
                      margin="dense"
                      fullWidth
                      defaultValue={today}
                      {...register('toDate')}
                      error={!!errors.toDate}
                    />
                  </Stack>
                  <Stack direction="row" spacing={2} sx={{width: '100%'}}>
                      <Controller
                        name="ditta"
                        control={control}
                        render={({ field }) => (
                          <Box sx={{ width: '25%' }}>
                            <Autocomplete
                              disablePortal
                              id="ditta"
                              disabled={disableClientiDrop}
                              options={DittaList}
                              getOptionLabel={(option) => option.label || option.id?.toString() || ""}
                              onChange={(event, value) => {
                                field.onChange(value?.id || "");
                                setDitta(value?.id || "");
                              }}
                              value={DittaList.find((item) => item.id === field.value) || null}
                              renderInput={(params) => <TextField {...params} margin="dense" label="Seleziona Ditta" fullWidth  error={!!errors.ditta}/>}
                            />
                           <Typography variant="caption" color="error">{errors.ditta?.message}</Typography>
                          </Box>
                        )}
                      />

                    <Controller
                        name="idcli"
                        control={control}
                        render={({ field }) => (
                             <Box sx={{width: '75%'}}>
                              <Autocomplete
                                {...field}
                                disablePortal
                                disabled={disableClientiDrop}
                                options={ClientiApiResponse?.results ?? []}
                                getOptionLabel={(option) => option.label || ""}
                                onChange={(event, value) => {field.onChange(value?.idcli || ""); setIdCli(value?.idcli || ""); }}
                                value={ClientiApiResponse?.results.find((item) =>  item.idcli === field.value) || null}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Seleziona Cliente"
                                        margin="dense"
                                        fullWidth
                                        error={!!errors.idcli}
                                    />
                                )}
                                />
                                  <Typography variant="caption" color="error">{errors.idcli?.message}</Typography>
                             </Box>
                            )}
                        />
                  </Stack>

                  <Stack spacing={1}>
                    <TextField
                      id="emailTo"
                      label="Email per invio Report"
                      type="email"
                      fullWidth
                      {...register('emailTo')}
                      onChange={(e) => setEmailTo(e.target.value)}
                    />
                  </Stack>

                  <Stack direction="row" spacing={2} justifyContent="flex-end" alignItems="flex-end">
                    <Button variant="contained" onClick={handleClose} color="error">CHIUDI</Button>
                    <Button disabled={!isValid} color="primary" type="submit" variant="contained">
                      SALVA
                    </Button>
                  </Stack>
                </Stack>
              </form>
            )}

            {datesConfirmed && (
              <Stack direction="row" spacing={2} alignItems="center">
                <Button variant="contained" onClick={handleClose} color="error">CHIUDI</Button>
                <Button variant="contained" onClick={handleDownload} color="primary">
                  Download {props.propformato}
                </Button>
                <Button disabled={!emailTo} variant="contained" onClick={handleEmail} color="primary">
                  Invia Email
                </Button>
                {isSuccessSendEmail && (
                  <Alert variant="filled" severity="success">
                    Invio email avvenuta correttamente a {emailTo} !!
                  </Alert>
                )}
              </Stack>
            )}

            {props.propformato === 'pdf' && datesConfirmed && blob && (
              <iframe src={window.URL.createObjectURL(blob)} width="100%" height="800"></iframe>
            )}
          </DialogContent>
        </Dialog>
          );

  };

export default ReportClientiVersoreJasper;
